import { useEffect, useMemo } from 'react'
import type { UseFormSetValue } from 'react-hook-form'
import type { FashionOrderFormValues } from '../fashionOrder.schema'
import type { ProductApiData } from '../types'
import { formatCurrency } from '../utils'

interface UseOrderTotalsParams {
  addedProducts: ProductApiData[]
  shippingCost: string
  setValue: UseFormSetValue<FashionOrderFormValues>
}

export interface FashionOrderTotals {
  quantity: number
  pieces: number
  subtotal: number
  total: number
}

export const useOrderTotals = ({ addedProducts, shippingCost, setValue }: UseOrderTotalsParams): FashionOrderTotals => {
  const totals = useMemo<FashionOrderTotals>(() => {
    const pieces = addedProducts.reduce((sum, p) => {
      const itemPieces = p.sizeQuantities
        ? Object.values(p.sizeQuantities).reduce((s, q) => s + q, 0)
        : p.totalItems || 0
      return sum + itemPieces
    }, 0)
    const subtotal = addedProducts.reduce((sum, p) => sum + (p.subtotal || 0), 0)
    const shippingVal = Number(shippingCost || 0) / 100

    return { quantity: addedProducts.length, pieces, subtotal, total: subtotal + shippingVal }
  }, [addedProducts, shippingCost])

  useEffect(() => {
    setValue('quantityItems', String(totals.quantity))
    setValue('quantityPieces', String(totals.pieces))
    setValue('totalCost', formatCurrency(totals.total))
  }, [totals, setValue])

  return totals
}
